import React from "react";
import styles from "./FieldError.module.scss";

const FieldError = ({ message }) => (
  <small className={styles.error}>{message}</small>
);

export default FieldError;
